export const heroItems = [
  { title: 'heroItem1Title', content: 'heroItem1Content' },
  { title: 'heroItem2Title', content: 'heroItem2Content' },
  { title: 'heroItem3Title', content: 'heroItem3Content' },
  { title: 'heroItem4Title', content: 'heroItem4Content' },
  { title: 'heroItem5Title', content: 'heroItem5Content' },
]
